import React, { FunctionComponent, useContext } from 'react';
import { ElementConfigType, PageEditorStoreContext } from '../store/PageEditorStore';
import { MyComponentType } from '@/pages2/DetailedDescription/component-factory/component-types';
import { toJS } from 'mobx';
import { ComponentIdEnum } from '@/pages2/DetailedDescription/component-factory/ComponentIdEnum';

type Props = ElementConfigType & { ComponentBasicRender: FunctionComponent<any> };

export const MultiRowContainer: MyComponentType<Props> = (props: Props) => {
  const pageEditorStore = useContext(PageEditorStoreContext);
  const { elements, privateSchema, styles } = props;
  const { length } = elements;

  return (
    <div
      style={pageEditorStore.isDevelopment ? { ...styles } : { marginBottom: '2px', ...styles }}
      className="flex w-full flex-col"
    >
      {elements.map((item, index) => (
        <props.ComponentBasicRender
          {...toJS(item)}
          styles={
            index !== length - 1 ? { marginBottom: privateSchema?.marginBottom, ...item.styles } : { ...item.styles }
          }
          key={item.nodeId}
        />
      ))}
    </div>
  );
};

MultiRowContainer.definition = {
  // id: 'rows-container-component',
  id: ComponentIdEnum.ROWS_CONTAINER_COMPONENT,
  name: '多行容器',
  icon: 'https://cdn.resource.youniverse.cc/d2c-app-dev/oZeo1jtD5TONnoGVDx5Ju.png?image_process=resize,w_200',
  position: 889, // 显示顺序
  config: {},
  privateSchema: {
    subContainersNumber: 2,
    marginBottom: 2,
  }, // 组件自己的属性 不能通用的部分
  styles: {},
};
